// extracted by mini-css-extract-plugin
export default {"OrderBanner":"Y9_P_Cba_1","Container":"txdvvorUGk","Title":"DZ6gSDyipb","AuthSection":"rhBL3Ig2tj","Logout":"dp7TI0VHJ_"};